import { RefreshCw } from 'lucide-react'
import { Button } from '@/contasis'

interface VersionBannerProps {
  visible: boolean
}

export function VersionBanner({ visible }: VersionBannerProps) {
  if (!visible) return null

  return (
    <div
      className="fixed inset-0 bg-[rgba(15,23,42,0.6)] backdrop-blur-sm flex items-center justify-center z-[9999] p-4"
      style={{ animation: 'fadeIn 0.25s ease-out' }}
    >
      <div
        className="bg-surface-0 rounded-lg p-6 max-w-[420px] w-full"
        style={{
          boxShadow: '0 20px 60px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.1)',
          animation: 'scaleIn 0.25s cubic-bezier(0.16,1,0.3,1)',
        }}
      >
        <div className="flex items-center gap-4 mb-5">
          <div className="w-12 h-12 flex-shrink-0 rounded-[10px] flex items-center justify-center bg-info-bg text-[24px]">
            😊
          </div>
          <div className="flex-1">
            <p className="text-[18px] font-semibold text-primary leading-[1.4]">
              ¡Senciyo mejoró para ti!
            </p>
          </div>
        </div>

        <p className="text-body-sm text-tertiary leading-[1.6] mb-6 pl-16">
          Tenemos una nueva actualización con mejoras pensadas especialmente para hacer tu trabajo más fácil y rápido. Actualiza ahora con un solo clic y disfruta lo nuevo.
        </p>

        <div className="flex justify-end">
          <Button
            variant="primary"
            size="md"
            icon={<RefreshCw size={15} />}
            iconPosition="left"
            onClick={() => window.location.reload()}
          >
            Actualizar ahora
          </Button>
        </div>
      </div>

    </div>
  )
}


